import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
export default function ReadyToSecureYourAssets() {
  return;
}